import { render, staticRenderFns } from "./AnchorText.vue?vue&type=template&id=a81cfdea&scoped=true&"
import script from "./AnchorText.vue?vue&type=script&lang=js&"
export * from "./AnchorText.vue?vue&type=script&lang=js&"
import style0 from "./AnchorText.vue?vue&type=style&index=0&id=a81cfdea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81cfdea",
  null
  
)

export default component.exports